import { render } from "./AppModals.vue?vue&type=template&id=89277910"
import script from "./AppModals.vue?vue&type=script&lang=ts"
export * from "./AppModals.vue?vue&type=script&lang=ts"
script.render = render

export default script